import { ScrollTrigger } from '../LibrariesImport';

export default class TextHighlightedBackground {
	static init() {
		this.els = document.querySelectorAll('.text-highlighted-background');

		if (!this.els.length) {
			return;
		}

		this.els.forEach((el) => {
			const content = el.innerHTML;
			el.innerHTML = `<span>${content.trim()}</span>`;

			ScrollTrigger.create({
				trigger: el,
				toggleClass: 'highlighted',
				once: true,
				start: 'top 50%',
			});
		});
	}
}